'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Icon = require('components/Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _hero = require('./hero.css');

var _hero2 = _interopRequireDefault(_hero);

var _filters = require('./filters.css');

var _filters2 = _interopRequireDefault(_filters);

var _contact = require('./contact.css');

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hero = function (_Component) {
  _inherits(Hero, _Component);

  function Hero() {
    _classCallCheck(this, Hero);

    var _this = _possibleConstructorReturn(this, (Hero.__proto__ || Object.getPrototypeOf(Hero)).call(this));

    _this.state = {
      filter: 'all',
      field: null,
      showHero: false
    };
    return _this;
  }

  _createClass(Hero, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          showHero: true
        });
      }, 550);
    }
  }, {
    key: 'handleFilter',
    value: function handleFilter(filter) {
      var onFilterChange = this.props.onFilterChange;

      this.setState({
        filter: filter
      });

      onFilterChange(filter);
    }
  }, {
    key: 'handleField',
    value: function handleField(newField) {
      var onFieldChange = this.props.onFieldChange;

      var oldField = this.state.field;
      var field = oldField === newField ? null : newField;

      this.setState({
        field: field
      });

      onFieldChange(field);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          isContact = _props.isContact,
          isWork = _props.isWork,
          isProject = _props.isProject,
          title = _props.title,
          subtitle = _props.subtitle,
          strap = _props.strap,
          bg = _props.bg,
          office = _props.office,
          studio = _props.studio,
          fields = _props.fields,
          technicalFields = _props.technicalFields,
          hideFields = _props.hideFields,
          info = _props.info;

      var background = bg !== undefined ? { backgroundImage: 'url(' + bg + ')' } : null;
      var heroClass = isWork || isProject || isContact ? _hero2.default.heroWork : _hero2.default.hero;
      var filter = this.state.filter;
      var field = this.state.field;

      var showHero = this.state.showHero;
      var titleBase = isProject ? _hero2.default.titleProject : _hero2.default.title;
      var titleClass = showHero ? titleBase : _hero2.default.titleHidden;
      var strapClass = showHero ? _hero2.default.strap : _hero2.default.strapHidden;
      var filterClass = showHero ? _filters2.default.filters : _filters2.default.filtersHidden;
      var contactClass = showHero ? _contact2.default.contact : _contact2.default.contactHidden;
      var subtitleClass = showHero ? _hero2.default.subtitle : _hero2.default.subtitleHidden;
      var fieldsClass = hideFields ? _filters2.default.fieldsHidden : _filters2.default.fields;

      return _react2.default.createElement(
        'section',
        { className: heroClass, style: background },
        _react2.default.createElement('div', { className: _hero2.default.overlay }),
        _react2.default.createElement(
          'div',
          { className: _hero2.default.inner },
          _react2.default.createElement(
            'h2',
            { className: titleClass },
            title
          ),
          isProject && _react2.default.createElement(
            'h3',
            { className: subtitleClass },
            subtitle
          ),
          !isWork && _react2.default.createElement('p', { className: strapClass, dangerouslySetInnerHTML: { __html: strap } }),
          isWork && _react2.default.createElement(
            'div',
            { className: filterClass },
            _react2.default.createElement(
              'h4',
              { className: _filters2.default.title },
              'filters'
            ),
            _react2.default.createElement(
              'div',
              { className: _filters2.default.holder },
              _react2.default.createElement(
                'div',
                { className: _filters2.default.inner },
                _react2.default.createElement(
                  'div',
                  {
                    className: filter === 'all' ? _filters2.default.itemActive : _filters2.default.item,
                    onClick: function onClick() {
                      return _this3.handleFilter('all');
                    }
                  },
                  'all'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: filter === 'creative' ? _filters2.default.itemActive : _filters2.default.item,
                    onClick: function onClick() {
                      return _this3.handleFilter('creative');
                    }
                  },
                  'creative'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: filter === 'technical' ? _filters2.default.itemActive : _filters2.default.item,
                    onClick: function onClick() {
                      return _this3.handleFilter('technical');
                    }
                  },
                  'technical'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: fieldsClass },
                filter === 'technical' && technicalFields.map(function (item, key) {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: field === item.field ? _filters2.default.fieldActive : _filters2.default.field,
                      key: key,
                      onClick: function onClick() {
                        return _this3.handleField(item.field);
                      }
                    },
                    item.field
                  );
                }),
                filter === 'creative' && fields.map(function (item, key) {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: field === item.field ? _filters2.default.fieldActive : _filters2.default.field,
                      key: key,
                      onClick: function onClick() {
                        return _this3.handleField(item.field);
                      }
                    },
                    item.field
                  );
                })
              )
            )
          ),
          isContact && _react2.default.createElement(
            'div',
            { className: contactClass },
            _react2.default.createElement(
              'div',
              { className: _contact2.default.col },
              _react2.default.createElement(
                'h4',
                { className: _contact2.default.title },
                'get in touch.'
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                _react2.default.createElement(
                  'a',
                  { href: 'mailto:' + info.email },
                  info.email
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                info.telephone
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _contact2.default.col },
              _react2.default.createElement(
                'h4',
                { className: _contact2.default.title },
                office.title
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                office.line1
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                office.line2
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                office.line3
              ),
              _react2.default.createElement(
                'a',
                { href: office.gmap, className: _contact2.default.map },
                _react2.default.createElement(_Icon2.default, { type: 'map', width: 13, height: 17 }),
                'View on google maps'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _contact2.default.col },
              _react2.default.createElement(
                'h4',
                { className: _contact2.default.title },
                studio.title
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                studio.line1
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                studio.line2
              ),
              _react2.default.createElement(
                'div',
                { className: _contact2.default.item },
                studio.line3
              ),
              _react2.default.createElement(
                'a',
                { href: studio.gmap, className: _contact2.default.map },
                _react2.default.createElement(_Icon2.default, { type: 'map', width: 13, height: 17 }),
                'View on google maps'
              )
            )
          )
        )
      );
    }
  }]);

  return Hero;
}(_react.Component);

Hero.propTypes = {
  isWork: _react.PropTypes.bool,
  isProject: _react.PropTypes.bool,
  isContact: _react.PropTypes.bool,
  title: _react.PropTypes.string,
  subtitle: _react.PropTypes.string,
  strap: _react.PropTypes.string,
  bg: _react.PropTypes.string,
  onFilterChange: _react.PropTypes.func
};

exports.default = Hero;


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/Hero.js
// module id = 41
// module chunks = 1